import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { showViewSourceModal, hideViewSourceModal } from '../../actions';
import { ViewSourceModal } from '../viewSourceModal';

const titleFromURL = url => {
    const urlParts = url.split('/');
    return urlParts.slice(5).join('/');
};

class ViewSegment extends Component {
    render() {
        const { showViewSourceModal, selectedURLs, oneSelected, inScene } = this.props;
        const lastSelectedUrl = selectedURLs[selectedURLs.length - 1] || "";
        
        return (
            <div key='viewsrcdiv'>
                <Button key='viewsrc' block type='button' disabled={!oneSelected || !inScene} onClick={() => showViewSourceModal()}>View Source</Button>
                <ViewSourceModal key='viewmodal' mediaURL={lastSelectedUrl} title={titleFromURL(lastSelectedUrl)}/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedURLs: state.ui.selectedURLs
    };
};

const mapDispatchToProps = {
    showViewSourceModal,
    hideViewSourceModal
};

ViewSegment.propTypes = {
    inScene:             PropTypes.bool.isRequired,
    oneSelected:         PropTypes.bool.isRequired,
    showViewSourceModal: PropTypes.func.isRequired,
    selectedURLs:        PropTypes.arrayOf(PropTypes.string).isRequired
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewSegment);



// WEBPACK FOOTER //
// ./src/components/actionBar/ViewSegment.js